import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, Outlet, useParams, useSearchParams } from 'react-router-dom'
import { DefaultTitle } from '../../../../_metronic/layout/components/header/page-title/DefaultTitle'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { knowledgeModel } from '../../auth'
import { getSingleGoodPractice } from '../../auth/core/_api'
import { ItemDetail } from '../share-components/ItemDetail'
import { Guideline } from './GuidelinePage'

const GuideRoute = () => {
    const [searchParams] = useSearchParams()

    var devBreadCrumbs: Array<PageLink> = [
        {
            title: 'แนวปฏิบัติที่ดี',
            path: '/guideline',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]

    const [goodPractice, setGoodPractice] = useState<knowledgeModel>()

    useEffect(() => {
        async function updateGoodPractice(item_id: string | null) {
            const item = await getSingleGoodPractice(item_id)
            setGoodPractice(item.data.knowledge)
        }

        if (searchParams && searchParams.get('kid')) {
            if (searchParams.get('kid') != null) {
                
                updateGoodPractice(searchParams.get('kid'))
            }
        }
    }, [searchParams.get('kid')])

    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='kw_detail'
                    element={
                        <>
                            <PageTitle breadcrumbs={devBreadCrumbs}>รายละเอียด</PageTitle>
                            <DefaultTitle />
                            <ItemDetail item={goodPractice} />
                        </>
                    }
                />

                <Route index element={<Guideline />} />
            </Route>
        </Routes>
    )
}

export default GuideRoute
